export const OEM_REQUEST = "OEM_REQUEST";
export const OEM_SUCCESS = "OEM_SUCCESS";
export const OEM_FAILURE = "OEM_FAILURE";
